<template>
  <EdroneTooltip
    :class="$options.name"
    :offset="[0, 16]"
    class="tw:!w-full"
    max-width="15rem"
    position="right"
    trigger-event="click"
    type="custom"
    @close="isOpen = false"
    @open="isOpen = true"
  >
    <MainMenuWorkspaceButton :active="isOpen" />

    <template #custom>
      <MainMenuWorkspaceContent />
    </template>
  </EdroneTooltip>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import EdroneTooltip from "edrone-components/EdroneTooltip.vue";
import MainMenuWorkspaceButton from "vue-app/components/MainMenu/MainMenuWorkspaceButton.vue";
import MainMenuWorkspaceContent from "vue-app/components/MainMenu/MainMenuWorkspaceContent.vue";

export default defineComponent({
  name: "MainMenuWorkspace",
  components: {
    MainMenuWorkspaceButton,
    EdroneTooltip,
    MainMenuWorkspaceContent,
  },
  setup() {
    const isOpen = ref(false);

    return {
      isOpen,
    };
  },
});
</script>
<style>
.tippy-box[data-theme~="custom"]:has(.MainMenuWorkspaceContent) {
  margin: 0.5rem;
}
</style>
